import { DestroyRef, inject, Injectable, signal } from '@angular/core';

/** Browser connectivity as a signal (`navigator.onLine` + `online`/`offline` events). */
@Injectable({
  providedIn: 'root',
})
export class ConnectivityService {
  private readonly online = signal(navigator.onLine);

  readonly isOnline = this.online.asReadonly();

  constructor() {
    const update = (): void => {
      this.online.set(navigator.onLine);
    };
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    inject(DestroyRef).onDestroy(() => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    });
  }
}
